// extracted by mini-css-extract-plugin
export default {"errorMessage":"TYGXPyfTVv"};